@if (vm(); as vm) {
  <div class="favorite-sites-header">
    <div class="favorite-sites-title">
      <h2>{{ 'FAVORITES' | translate }}</h2>
      <span class="total-favorites">{{ vm.favoriteSites.length }}{{ 'TOTAL_FAVORITES' | translate }}</span>
    </div>
    @if (vm.favoriteSites.length > 0) {
      @if (editMode()) {
        <button type="button" class="edit-button" (click)="editMode.set(false)">{{ 'COMPLETE' | translate }}</button>
      } @else {
        <button type="button" class="edit-button" (click)="editMode.set(true)">{{ 'UPDATE' | translate }}</button>
      }
    }
  </div>

  @if (vm.favoriteSites.length > 0) {
    <div class="favorite-sites-list">
      @for (favoriteSite of vm.favoriteSites; track favoriteSite.siteId) {
        <app-favorite-item [favoriteSite]="favoriteSite" [editMode]="editMode()" />
      }
    </div>
  } @else if (vm.loading) {
    <div class="favorite-sites-list" aria-hidden="true">
      @for (row of skeletonRows; track row) {
        <div class="favorite-skeleton-row">
          <div class="favorite-skeleton icon"></div>
          <div class="favorite-skeleton texts">
            <div class="favorite-skeleton name"></div>
            <div class="favorite-skeleton date"></div>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="empty-favorites">
      <p>{{ 'FAVORITES_DESCRIPTION_1' | translate }}</p>
      <p>{{ 'FAVORITES_DESCRIPTION_2' | translate }}</p>
    </div>
  }
}
